import {
  MealCountVersion,
  ReceivedMeals,
  ServingLine
} from '@/models';

export class SaveMealCountRequest {
  constructor(
    public version: MealCountVersion,
    public receivedMeals: ReceivedMeals | undefined = undefined,
    public servingLine: ServingLine | undefined = undefined
  ) {
  }
}
